/* eslint-disable no-self-compare */
import { TableBody, TableCell, TableRow } from '@material-ui/core';
import React from 'react';
import {
  formatIV,
  formatPercent,
  formatVWAP,
} from '../../../utils/numberFormatFunc';
import styles from '../../../Pages/OptionsBoard/OptionsBoardStyles';
import { useSelector } from 'react-redux';

const AdminAccessTableBody = ({ localOD, orderBy, order }) => {
  /** @type {import('../../../typings').IStateReducerState} */
  const { isMobile } = useSelector((state) => state.appReducer);
  return (
    <TableBody>
      {localOD
        .sort((a, b) => {
          if (
            !orderBy ||
            (!(
              typeof a[orderBy] === 'number' || typeof a[orderBy] === 'string'
            ) &&
              typeof a[orderBy] === typeof a[orderBy])
          )
            return 0;
          if (orderBy === 'bidside' || orderBy === 'askside') {
            return order === 'desc'
              ? a[orderBy] / a['volume'] - b[orderBy] / b['volume']
              : b[orderBy] / b['volume'] - a[orderBy] / a['volume'];
          } else {
            if (typeof a[orderBy] === 'number')
              return order === 'desc'
                ? a[orderBy] - b[orderBy]
                : b[orderBy] - a[orderBy];
            else {
              return order === 'desc'
                ? a[orderBy].localeCompare(b[orderBy])
                : b[orderBy].localeCompare(a[orderBy]);
            }
          }
        })
        .map((row) => (
          <TableRow style={{ height: '5px' }} key={row.time}>
            <TableCell
              style={{ ...styles.modalTableRow, padding: 0 }}
              align="center"
            >
              {row.time}
            </TableCell>
            <TableCell
              style={{ ...styles.modalTableRow, padding: 0 }}
              align="center"
            >
              {row.volume}
            </TableCell>
            <TableCell
              style={{ ...styles.modalTableRow, padding: 0 }}
              align="center"
            >
              ${formatVWAP(row.vwap)}
            </TableCell>
            {!isMobile && (
              <TableCell
                style={{
                  ...styles.modalTableRowGray,
                  padding: 0,
                }}
                align="right"
              >
                {formatPercent(row.bidside / row.volume)}%
              </TableCell>
            )}
            {!isMobile && (
              <TableCell
                style={{
                  ...styles.modalTableRowGray,
                  padding: 0,
                }}
                align="right"
              >
                {formatPercent(row.askside / row.volume)}%
              </TableCell>
            )}
            <TableCell
              style={{ ...styles.modalTableRow, padding: 0 }}
              align="center"
            >
              ${formatVWAP(row.spot)}
            </TableCell>
            <TableCell
              style={{
                ...styles.modalTableRowYellow,
                padding: 0,
              }}
              align="center"
            >
              {formatIV(row.ivol)}
            </TableCell>
            <TableCell
              style={{
                ...styles.modalTableRow,
                padding: 0,
                width: '30px',
              }}
              align="center"
            >
              {row.complex}
            </TableCell>
          </TableRow>
        ))}
    </TableBody>
  );
};

export default AdminAccessTableBody;



// WEBPACK FOOTER //
// ./src/components/Modals/VolumeModal/AdminAccessTableBody.jsx